import React from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import Pagetest from './Pagetest'
import Testimonial from '../Home/Testimonial'
import Footer from '../Home/Footer'
import { CartProvider } from 'react-use-cart'

function AllTestimonial() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <Pagetest/>
        <Testimonial/>
        <Footer/>
    </CartProvider>
  )
}

export default AllTestimonial